import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=05dc2028&"
import script from "./HelpPage.vue?vue&type=script&lang=js&"
export * from "./HelpPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports